import React from "react"
import cx from "classnames"
import {AsyncPaginate} from "react-select-async-paginate"
import {KlassDropdownAsyncProps} from "./KlassDropdownAsync"
import {components} from "react-select"
import {dropdownStyle} from "./dropdownStyle"
import styles from "./KlassDropAsyncPaginate.module.css"

const customMultiValueRemove = (components) => (props) => {
    if (props.data.isFixed) {
        return null
    }

    return <components.MultiValueRemove {...props} />
}

export function KlassDropAsyncPaginate(props: KlassDropdownAsyncProps) {
    const {
        stylesCustom,
        valueKey,
        labelKey,
        isMulti,
        checkRemoveButton,
        readOnly = false,
        isClearable,
        className,
        refData,
        ...rest
    } = props
    let valueKeySelect = valueKey || "id"
    let labelKeySelect = labelKey || "name"
    let styles = dropdownStyle
    if (stylesCustom) styles = {...styles, ...stylesCustom}
    const customProps = {...rest, styles}

    return (
        <AsyncPaginate
            cacheOptions
            defaultOptions
            getOptionValue={(option: any) => option[valueKeySelect]}
            getOptionLabel={(option: any) => option[labelKeySelect]}
            closeMenuOnSelect
            isMulti={isMulti}
            menuIsOpen={readOnly ? false : undefined}
            isSearchable={!readOnly}
            isClearable={!!isClearable && !readOnly}
            classNamePrefix="klassapp-dropdown"
            className={cx("klassapp-dropdown", className, {readOnly})}
            ref={refData}
            loadOptions={rest.loadOptions}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            components={checkRemoveButton ? {MultiValueRemove: customMultiValueRemove(components)} : undefined}
            {...customProps}
        />
    )
}

const DropdownIndicator = (props) => {
    return (
        <div className={styles.orButtonContainer}>
            <components.DropdownIndicator {...props}>
                <div onClick={props.onClickOr} className={styles.orButton}>
                    <span className={styles.orText}>OR</span>
                </div>
            </components.DropdownIndicator>
        </div>
    )
}

const MultiValueContainer = (props) => {
    const isOr = !!props.data.or
    const courseId = props.data.courseId
    const currentIndex = props.selectProps.value.findIndex((item) => item.courseId === courseId) ?? 0

    if (isOr) {
        return (
            <div className={styles.orLabelContainerLeft}>
                <components.MultiValueContainer {...props} />
                <span className={styles.orLabel}>OR</span>
            </div>
        )
    } else if (currentIndex - 1 >= 0 && props.selectProps.value[currentIndex - 1].or) {
        return (
            <div className={styles.orLabelContainer}>
                <components.MultiValueContainer {...props} />
            </div>
        )
    }
    return <components.MultiValueContainer {...props} />
}

export function KlassDropConditionAsyncPaginate(props: KlassDropdownAsyncProps) {
    const {
        stylesCustom,
        valueKey,
        labelKey,
        isMulti,
        readOnly = false,
        isClearable,
        onClickOr,
        className,
        refData,
        ...rest
    } = props
    let valueKeySelect = valueKey || "id"
    let labelKeySelect = labelKey || "name"
    let styles = dropdownStyle
    if (stylesCustom) styles = {...styles, ...stylesCustom}
    const customProps = {...rest, styles}

    return (
        <AsyncPaginate
            cacheOptions
            defaultOptions
            getOptionValue={(option: any) => option[valueKeySelect]}
            getOptionLabel={(option: any) => option[labelKeySelect]}
            closeMenuOnSelect
            isMulti={isMulti}
            components={{
                DropdownIndicator: (props) => <DropdownIndicator onClickOr={onClickOr} {...props} />,
                MultiValueContainer
            }}
            menuIsOpen={readOnly ? false : undefined}
            isSearchable={!readOnly}
            isClearable={isClearable && !readOnly}
            classNamePrefix="klassapp-dropdown"
            className={cx("klassapp-dropdown", className, {readOnly})}
            ref={refData}
            loadOptions={rest.loadOptions}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            {...customProps}
        />
    )
}
